import React from 'react';

export const DataTableHeader = ({ children, style, className }) =>
    <thead style={style} className={className}>{children}</thead>;

export const DataTableBody = ({ children, className }) =>
    <tbody className={className}>{children}</tbody>;

export const DataTableRow = ({ children, className, style, onClick }) =>
    <tr style={style} className={className} {...onClick ? { onClick } : {}}>{children}</tr>

export const DataTableCell = ({ children, className, id, style, onClick, width, ...rest }) =>
    <td style={style} className={className} id={id} width={width}
        {...onClick ? { onClick } : {}} {...rest}>
        {children}
    </td>;

export const DataTable = props =>
    <table id={props.id} width={props.width} className={`bordered ${props.className || ''}`}>
        {props.children}
    </table>

export const DataTableLoading = ({ children, className }) =>
(<div className={`text-center mt-3 ${className}`} >
    <span className="mb-0">{children || "Loading..."}</span>
</div>)

export const DataTableRecordsNotFound = ({ children, className }) =>
(<div className={`text-center mt-3 ${className}`}>
    <span className="mb-0">{children || "No records found"}</span>
</div>)

DataTable.Cell = DataTableCell;
DataTable.Header = DataTableHeader;
DataTable.Body = DataTableBody;
DataTable.Row = DataTableRow;
DataTable.Loading = DataTableLoading;
DataTable.RecordsNotFound = DataTableRecordsNotFound;

